<template>
  <fragment>
    <CardModule untitle>
      <v-form @submit.prevent="filterInvite()" class="search-forms" ref="form">
        <v-expansion-panels flat>
          <v-expansion-panel>
            <v-expansion-panel-header class="body-1 font-weight-bold mt-n7">
              {{ $t("common.filters") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="mb-5">
              <v-row>
                <v-col cols="12" md="3">
                  <BaseTextField
                    :label="$t('marketing.invitation.name')"
                    required
                    :placeholder="$t('marketing.invitation.search-by-subject')"
                    type="text"
                    hide-details
                    v-model="filter.nome"
                  >
                  </BaseTextField>
                </v-col>
                <v-col cols="12" md="3">
                  <BaseSelect
                    label="Status"
                    required
                    type="text"
                    hide-details
                    v-model="filter.status"
                  >
                  </BaseSelect>
                </v-col>
                <v-col cols="12" md="3" sm="4">
                  <v-menu
                    offset-y
                    ref="menu"
                    v-model="menu"
                    min-width="auto"
                    transition="scale-transition"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseTextField
                        clearable
                        hide-details
                        :label="$t('marketing.invitation.initial-date')"
                        placeholder="dd/mm/aaaa"
                        v-mask="'##/##/####'"
                        v-model="filter.initDateView"
                        v-on="on"
                        v-bind="attrs"
                        :append-icon="$config.icons.calendar"
                      />
                    </template>

                    <v-date-picker
                      locale="pt"
                      v-model="filter.initDate"
                      :active-picker.sync="activePicker"
                      :header-color="$config.dados.corinputs"
                      :color="$config.dados.corinputs"
                      @change="save"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="3" sm="4">
                  <v-menu
                    offset-y
                    ref="menu2"
                    v-model="menu2"
                    min-width="auto"
                    transition="scale-transition"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseTextField
                        clearable
                        hide-details
                        :label="$t('marketing.invitation.final-date')"
                        placeholder="dd/mm/aaaa"
                        v-mask="'##/##/####'"
                        v-model="filter.endDateView"
                        v-on="on"
                        v-bind="attrs"
                        :append-icon="$config.icons.calendar"
                      />
                    </template>

                    <v-date-picker
                      locale="pt"
                      v-model="filter.endDate"
                      :active-picker.sync="activePicker2"
                      :header-color="$config.dados.corinputs"
                      :color="$config.dados.corinputs"
                      @change="save2"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="d-flex justify-end">
                  <BaseButton
                    tabindex="13"
                    variant="filter"
                    class="button rounded-xxl"
                    type="submit"
                  >
                    {{ $t("marketing.invitation.filter") }}
                  </BaseButton>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>
      <v-row>
        <v-col>
          <v-data-table
            class="rounded-lg"
            :no-data-text="$t('marketing.invitation.no-invitations-register')"
            :loading-text="$t('common.searching-info')"
            mobile-breakpoint="0"
            :headers="headers"
            :items-per-page="10"
            :items="inviteEvent || []"
            :header-props="{
              class: 'rounded-t-lg',
              color: $config.dados.corinputs,
            }"
            :footer-props="{
              class: 'rounded-b-lg',
              itemsPerPageOptions: [10, 20, 50],
              itemsPerPageText: $t('marketing.invitation.invitations-per-page'),
            }"
          >
            <template v-slot:item.actions="{ item }">
              <div style="display: flex; justify-content: center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      width="30"
                      small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="mr-2"
                      :disabled="item.finalizado == '1'"
                      @click="goToEdit(item, 'edit')"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("common.edit") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      width="30"
                      small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="goToSend(item)"
                      class="mr-2"
                    >
                      <v-icon>mdi-send-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("marketing.invitation.send-invitations") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      width="30"
                      small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="openConfirm(item)"
                      class="mr-2"
                    >
                      <v-icon>mdi-file-remove-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("common.delete") }}</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.finalizado="{ item }">
              <div style="display: flex; justify-content: center"></div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" text plain>
                    {{ item.finalizado }}
                  </v-btn>
                </template>
                <span v-if="item.finalizado == '1'">Definitivo</span>
                <span v-if="item.finalizado == '0'">Rascunho</span>
              </v-tooltip>
              <div style="display: flex; justify-content: center"></div>
            </template>
            <template v-slot:item.finalizado="{ item }">
              {{
                item.finalizado == 1
                  ? $t("marketing.invitation.definitive")
                  : $t("marketing.invitation.draft")
              }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </CardModule>
    <AddGuests />
    <confirm-modal
      v-model="deleteConvite"
      @confirm="removeConvite(idemail_marketing)"
      @cancel="deleteConvite = false"
      title="Confirmação"
      subtitle="Tem certeza de que deseja excluir o template?"
    />
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import confirmModal from "@/components/global/newConfirmDialog.vue";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import displayHelpers from "@/mixins/breakpoints.mixins";
import BaseButton from "@/components/forms/BaseButton.vue";
import AddGuests from "@/components/marketing/invitation/form/AddGuests.vue";
import dayjs from "dayjs";
export default {
  name: "ListInvite",
  mixins: [displayHelpers],
  components: {
    BaseTextField,
    BaseSelect,
    BaseButton,
    CardModule,
    AddGuests,
    confirmModal,
  },
  data() {
    return {
      filter: {
        initDate: "",
        initDateView: "",
        endDate: "",
        endDateView: "",
        status: "",
        assunto: "",
      },
      deleteConvite: false,
      dayjs: dayjs,
      activePicker: null,
      activePicker2: null,
      date: null,
      menu: false,
      menu2: false,
    };
  },
  computed: {
    ...mapGetters(["inviteEvent", "AddGuests", "getTypeInvite"]),
    headers() {
      return [
        {
          text: this.$t("marketing.invitation.subject"),
          align: "center",
          value: "nome",
          width: 130,
        },
        {
          text: this.$t("marketing.invitation.creation-date-time"),
          align: "center",
          value: "data_cadastro",
          width: 90,
        },
        {
          text: this.$t("marketing.invitation.type"),
          align: "center",
          value: "tipo",
          width: 90,
        },
        {
          text: this.$t("marketing.invitation.total-sendings"),
          align: "center",
          value: "envios",
          width: 120,
        },
        {
          text: "Status",
          align: "center",
          value: "finalizado",
          width: 120,
        },
        {
          text: this.$t("common.actions"),
          align: "center",
          value: "actions",
          width: 120,
        },
      ];
    },
    infoEvent() {
      return JSON.parse(localStorage.getItem("eventoData"));
    },
    resetEvent() {
      return localStorage.removeItem("eventoData");
    },
    showEventInvitePage() {
      if (this.infoEvent !== null) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      "fetchInviteEvent",
      "setOpenAddGuests",
      "setSaveId",
      "setEdit",
      "setTypeInvite",
      "deleteInvite",
    ]),
    filterInvite() {
      const idproduto = this.infoEvent?.idproduto;
      const tipo = this.infoEvent !== null ? "EVENTO" : "PRODUTOR";
      const dataInit =
        this.filter.initDate === "" ? "" : this.filter.initDate + " 00:00";
      const dataEnd =
        this.filter.endDate === "" ? "" : this.filter.endDate + " 23:59";
      let params = {
        idproduto,
        tipo,
        nome: this.filter.nome,
        dt_inicial: dataInit,
        dt_final: dataEnd,
      };
      if (this.infoEvent !== null) {
        return this.fetchInviteEvent(params);
      } else {
        return this.fetchInviteEvent(params);
      }
    },
    openConfirm(item) {
      this.deleteConvite = true;
      this.deleteItem = item;
    },
    removeConvite() {
      const data = {
        idemail_marketing: this.deleteItem.idemail_marketing,
      };
      this.deleteInvite(data);
      this.deleteConvite = false;
      this.filterInvite();
    },
    // eslint-disable-next-line no-unused-vars
    goToEdit(id, type) {
      const data = {
        idemail_marketing: id.idemail_marketing,
      };
      this.setEdit(data);
      this.$router.push({
        name: "InviteFormEdit",
        params: { id: id.idemail_marketing },
      });
      this.setTypeInvite(type);
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      return str.replace(/[^a-z0-9]/gi, "");
    },
    save(date) {
      this.$refs.menu.save(date);
      this.filter.initDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.filter.endDateView = dayjs(date).format("DD/MM/YYYY");
    },
    goToSend(id) {
      this.setOpenAddGuests();
      this.setSaveId(id.idemail_marketing);
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
  },

  destroyed() {
    this.resetEvent;
  },
};
</script>
